import type { DragEvent } from "react";
import type { SurfDeck, SurfSlide } from "@vida/surf-core";
import { SlideCanvas } from "./SlideCanvas";

type Props = {
  deck: SurfDeck;
  slide: SurfSlide;
  slideIndex: number;
  slideBackgroundUrl?: string | null;
  layerImageUrls?: Record<string, string>;
  active?: boolean;
  onClick?: () => void;
  canMoveUp?: boolean;
  canMoveDown?: boolean;
  onMoveUp?: () => void;
  onMoveDown?: () => void;
  draggable?: boolean;
  onDragStart?: (e: DragEvent) => void;
  onDragOver?: (e: DragEvent) => void;
  onDrop?: (e: DragEvent) => void;
  onDragEnd?: () => void;
  dragOver?: boolean;
};

export function SlideThumb({
  deck,
  slide,
  slideIndex,
  slideBackgroundUrl,
  layerImageUrls = {},
  active,
  onClick,
  canMoveUp,
  canMoveDown,
  onMoveUp,
  onMoveDown,
  draggable,
  onDragStart,
  onDragOver,
  onDrop,
  onDragEnd,
  dragOver,
}: Props) {
  const showReorder = onMoveUp || onMoveDown;

  return (
    <div
      className={[
        "slide-thumb-wrap",
        dragOver ? "slide-thumb-wrap--drag-over" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      onDragOver={onDragOver}
      onDrop={onDrop}
    >
      <button
        type="button"
        className={active ? "slide-thumb slide-thumb--rendered active" : "slide-thumb slide-thumb--rendered"}
        onClick={onClick}
        aria-label={`Slide ${slideIndex + 1}`}
        aria-current={active ? "true" : undefined}
        draggable={draggable}
        onDragStart={onDragStart}
        onDragEnd={onDragEnd}
      >
        <div className="slide-thumb-canvas" aria-hidden>
          <SlideCanvas
            deck={deck}
            slide={slide}
            slideBackgroundUrl={slideBackgroundUrl}
            layerImageUrls={layerImageUrls}
            selectedLayerIds={[]}
            showGuides={false}
            readOnly
            compact
            onSelectLayer={() => undefined}
            onLayerRect={() => undefined}
            onLayerContent={() => undefined}
          />
        </div>
        <span className="slide-thumb-label">Slide {slideIndex + 1}</span>
      </button>
      {showReorder && (
        <div className="slide-thumb-reorder">
          <button
            type="button"
            className="surf-icon-btn"
            aria-label={`Sposta slide ${slideIndex + 1} su`}
            disabled={!canMoveUp}
            onClick={(e) => {
              e.stopPropagation();
              onMoveUp?.();
            }}
          >
            ↑
          </button>
          <button
            type="button"
            className="surf-icon-btn"
            aria-label={`Sposta slide ${slideIndex + 1} giù`}
            disabled={!canMoveDown}
            onClick={(e) => {
              e.stopPropagation();
              onMoveDown?.();
            }}
          >
            ↓
          </button>
        </div>
      )}
    </div>
  );
}
